import React from 'react';
import styles from './consultancyStep.module.css';

interface StepContentProps {
  children: React.ReactNode;
}

const StepContent: React.FC<StepContentProps> = ({ children }) => (
  <div className={styles.content}>{children}</div>
);

export default StepContent;
